// eslint-disable-next-line no-shadow
export enum GenerationStyleTypes {
	MODEL = 'model',
	FLUX = 'flux',
}
